<template>    
    <label class="d-block text-left">
        {{ modelValue.title }}
        <span v-if="modelValue.mandatory" class="text-danger">*</span>
    </label>
    <v-table>
        <thead>
            <tr>
                <th class="text-left font-weight-bold"></th>
                <th v-for="(columnName, columnIndex) in modelValue.columns" :key="columnIndex"
                    class="text-center font-weight-bold">
                    {{ columnName }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(rowName, rowIndex) in modelValue.rows" :key="{ rowIndex }">
                <td class="text-left font-weight-medium">
                    {{ rowName }}
                </td>
                <td v-for="(columnName, columnIndex) in modelValue.columns" :key="`${rowIndex}-${columnIndex}`">
                    <v-checkbox 
                        :model-value="modelValue.value[rowIndex][columnIndex]"
                        @update:model-value="handleChange($event, rowIndex, columnIndex)" 
                        hide-details
                        class="ma-0 pa-0 d-flex justify-center"
                        >
                    </v-checkbox>
                </td>
            </tr>
        </tbody>
    </v-table>
</template>

<script>
import { dumpMatrix } from '../../utils/matrix.js';

export default {
    name: 'CheckboxGridComponent',

    props: ['modelValue',], //modelValue - it the name of the prop that will be used for v-model binding (from parent component)
    emits: ['update:modelValue'],

    methods: {
        handleChange(value, rowIndex, columnIndex) {
            console.log("Current model", this.modelValue);
            console.log(`Row index ${rowIndex}, Column index: ${columnIndex}`)
            console.log("Radio checked = ", value);

            let newModelValue = { 
                ...this.modelValue,
                error: '', // Reset any previous error
            };

            // Check if 'value' key is set at the modelValue level
            if (!('value' in this.modelValue)) { // Default values          
                console.log("Initializing matrix");      
                newModelValue.value = this.emptyMatrix(this.modelValue.rows.length, this.modelValue.columns.length, false); 
            }

            // Set correct value
            newModelValue.value[rowIndex][columnIndex] = value;
            console.log("New model", newModelValue);
            console.log(dumpMatrix(newModelValue.value));

            // Trigger new model
            this.$emit('update:modelValue', newModelValue);
        },

        

        // emptyMatrix(rows, columns, defaultValue=false) {
        //     let matrix = [];
        //     for (var i = 0; i < rows; i++) {
        //         matrix[i] = [];
        //         for (var j = 0; j < columns; j++) {
        //             matrix[i][j] = defaultValue;
        //         }
        //     }
        //     return matrix;
        // }
    }

}
</script>

<style scoped></style>